import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'
import PostsLatest from './PostsLatest'
import PostsOverview from './PostsOverview'

export default function PostsShell({ fields, index }: LosseFlexShellProps) {
  const types: LosseFlexShellType = {
    posts_latest: PostsLatest,
    posts_overview: PostsOverview
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}
